module.exports = __webpack_public_path__ + "6c2e7b16db8090d1a61cce88cce6d873.svg";